import { render, staticRenderFns } from "./hot-guests.vue?vue&type=template&id=60c9fa1d&scoped=true&"
import script from "./hot-guests.vue?vue&type=script&lang=js&"
export * from "./hot-guests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9fa1d",
  null
  
)

export default component.exports